import React, { useState } from "react";
import { ObjectFieldTemplateProps } from "@rjsf/utils";

interface CategoryInfo {
  name: string;
  key: string;
  templates: Array<{
    name: string;
    indicators: string[];
  }>;
}

export default function MaatregelenObjectTemplate({
  properties,

  schema
}: ObjectFieldTemplateProps) {
  const [showOverview, setShowOverview] = useState(true);
  
  // Extract category information from the schema meta
  const categories: CategoryInfo[] = schema.meta?.categories || [];
  
  // Check if sector (used to be 'Leidraad') is "HNN Infra" to enable detail mode
  const isInfraLeidraad = schema.meta?.sector.toLowerCase().indexOf("infra") > -1;
  
  // Sort properties based on the order in categories
  const sortedProperties = properties.sort((a, b) => {
    const aIndex = categories.findIndex(cat => cat.key === a.name);
    const bIndex = categories.findIndex(cat => cat.key === b.name);
    return aIndex - bIndex;
  });

  return (
   
      <div className="flex flex-col flex-auto">
        {showOverview ? (
          <>
            <div className="">
           
              
              {sortedProperties.map((property) => {
                const category = categories.find(cat => cat.key === property.name);
                if (!category) return null;
                
                return (
                  <div key={property.name} className="mb-4">

                    <div className={`overviewMode ${isInfraLeidraad ? 'infra-leidraad' : ''}`}>
                      {property.content}
                    </div>
                  </div>
                );
              })}
            </div>
            
            {isInfraLeidraad && (
              <button 
                type="button"
                onClick={() => setShowOverview(false)} 
                className="button button-primary self-end"
              >
                Volgende
              </button>
            )}
          </>
        ) : (
          <>
            {/* Detail view showing actual RJSF form fields for scores and toelichting */}
            <div className="mt-4">
            
              
              {sortedProperties.map((property) => {
                const category = categories.find(cat => cat.key === property.name);
                if (!category) return null;
                
                return (
                  <div key={property.name} className="mb-4">
                  
                    <div className="detailMode">
                      {property.content}
                    </div>
                  </div>
                );
              })}
            </div>
            
            <button 
              type="button"
              onClick={() => setShowOverview(true)} 
              className="button button-outline self-start"
            >
              Vorige
            </button>
          </>
        )}
      </div>
    
  );
}